export default [{
  "FirstName": "Doctor",
  "LastName": "Test",
  "PracticeName": "[Facility/Practice Name]",
  "Address1": "450 N. Bedford Dr. Ste 307",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "XXXXXXXXXX",
  "Distance": 0,
  "DistanceIndex": 0,
  "Lat": 34.05,
  "Lng": -118.4057,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.069-118.406",
  "FullAddress": "450 N. Bedford Dr. Ste 307, Beverly Hills, CA 90210",
  "NicePhone": "310-497-8900"
}, {
  "FirstName": "Nurse Practitioner",
  "LastName": "Test",
  "PracticeName": null,
  "Address1": "450 N. Bedford Dr. Ste 307",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "XXXXXXXXXX",
  "Distance": 0,
  "DistanceIndex": 4,
  "Lat": 34.06,
  "Lng": -118.4057,
  "Indexing": 0,
  "Category": "2",
  "coordHash": "34.069-118.406",
  "FullAddress": "450 N. Bedford Dr. Ste 307, Beverly Hills, CA 90210",
  "NicePhone": "310-497-8900"
}, {
  "FirstName": "Physician",
  "LastName": "Test",
  "PracticeName": null,
  "Address1": "450 N. Bedford Dr. Ste 307",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "XXXXXXXXXX",
  "Distance": 0,
  "DistanceIndex": 5,
  "Lat": 34.08,
  "Lng": -118.4057,
  "Indexing": 0,
  "Category": "3",
  "coordHash": "34.069-118.406",
  "FullAddress": "450 N. Bedford Dr. Ste 307, Beverly Hills, CA 90210",
  "NicePhone": "310-497-8900"
}, {
  "FirstName": "Jeffrey",
  "LastName": "Gandin",
  "PracticeName": null,
  "Address1": "450 N. Bedford Dr. Ste 307",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3104978900",
  "Distance": 0,
  "DistanceIndex": 1,
  "Lat": 34.069,
  "Lng": -118.4057,
  "Indexing": 0,
  "Category": "4",
  "coordHash": "34.069-118.406",
  "FullAddress": "450 N. Bedford Dr. Ste 307, Beverly Hills, CA 90210",
  "NicePhone": "310-497-8900"
}, {
  "FirstName": "Julie",
  "LastName": "Anderson",
  "PracticeName": null,
  "Address1": "9107 Wilshire Blvd. Ste. 301",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3104806767",
  "Distance": 0,
  "DistanceIndex": 2,
  "Lat": 34.06713,
  "Lng": -118.39009,
  "Indexing": 0,
  "Category": "2",
  "coordHash": "34.0671-118.39",
  "FullAddress": "9107 Wilshire Blvd. Ste. 301, Beverly Hills, CA 90210",
  "NicePhone": "310-480-6767"
}, {
  "FirstName": "Guven",
  "LastName": "Uzun",
  "PracticeName": null,
  "Address1": "415 N Crescent Dr. Ste 220",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3108882877",
  "Distance": 0,
  "DistanceIndex": 6,
  "Lat": 34.0715,
  "Lng": -118.40056,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.0715-118.401",
  "FullAddress": "415 N Crescent Dr. Ste 220, Beverly Hills, CA 90210",
  "NicePhone": "310-888-2877"
}, {
  "FirstName": "Criselda",
  "LastName": "Abad- Santos",
  "PracticeName": "Criselda C Abad- Santos, Md",
  "Address1": "468 North Camden Drive Suite 200",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3106013198",
  "Distance": 0,
  "DistanceIndex": 3,
  "Lat": 34.06975,
  "Lng": -118.40516,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.0697-118.405",
  "FullAddress": "468 North Camden Drive Suite 200, Beverly Hills, CA 90210",
  "NicePhone": "310-601-3198"
}, {
  "FirstName": "Sophie",
  "LastName": "Duriez",
  "PracticeName": null,
  "Address1": "9400 Brighton Way #407",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3102718407",
  "Distance": 0,
  "DistanceIndex": 7,
  "Lat": 34.07027,
  "Lng": -118.40104,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.0703-118.401",
  "FullAddress": "9400 Brighton Way #407, Beverly Hills, CA 90210",
  "NicePhone": "310-271-8407"
}, {
  "FirstName": "Edward",
  "LastName": "Riceberg",
  "PracticeName": "Edward L. Riceberg, Md",
  "Address1": "9400 Brighton Way #410",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3105508028",
  "Distance": 0,
  "DistanceIndex": 8,
  "Lat": 34.07039,
  "Lng": -118.40111,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.0704-118.401",
  "FullAddress": "9400 Brighton Way #410, Beverly Hills, CA 90210",
  "NicePhone": "310-550-8028"
}, {
  "FirstName": "Steven",
  "LastName": "Jacobs",
  "PracticeName": null,
  "Address1": "436 N. Bedford Dr. Ste. 214",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3102712328",
  "Distance": 0,
  "DistanceIndex": 9,
  "Lat": 34.06855,
  "Lng": -118.40568,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.0686-118.406",
  "FullAddress": "436 N. Bedford Dr. Ste. 214, Beverly Hills, CA 90210",
  "NicePhone": "310-271-2328"
}, {
  "FirstName": "Barry",
  "LastName": "Friedman",
  "PracticeName": null,
  "Address1": "435 North Bedford Dr. #112",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90210",
  "Phone": "3102744372",
  "Distance": 0,
  "DistanceIndex": 10,
  "Lat": 34.06831,
  "Lng": -118.40592,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.0683-118.406",
  "FullAddress": "435 North Bedford Dr. #112, Beverly Hills, CA 90210",
  "NicePhone": "310-274-4372"
}, {
  "FirstName": "Kamyar",
  "LastName": "Cohanshohet",
  "PracticeName": "Serenity Medical Center",
  "Address1": "9730 Wilshire Blvd. Ste. 202",
  "Address2": null,
  "City": "Beverly Hills",
  "State": "CA",
  "ZipCode": "90212",
  "Phone": "4242429355",
  "Distance": 1.7315237522125244,
  "DistanceIndex": 11,
  "Lat": 34.10963,
  "Lng": -118.38129,
  "Indexing": 0,
  "Category": "1",
  "coordHash": "34.1096-118.381",
  "FullAddress": "9730 Wilshire Blvd. Ste. 202, Beverly Hills, CA 90212",
  "NicePhone": "424-242-9355"
}, {
  "FirstName": "Fred",
  "LastName": "Wilkey",
  "PracticeName": null,
  "Address1": "9056 Santa Monica Blvd Suite 306a",
  "Address2": null,
  "City": "West Hollywood",
  "State": "CA",
  "ZipCode": "90069",
  "Phone": "3106594455",
  "Distance": 1.935078501701355,
  "DistanceIndex": 12,
  "Lat": 34.08164,
  "Lng": -118.38859,
  "Indexing": 0,
  "Category": "2",
  "coordHash": "34.0816-118.389",
  "FullAddress": "9056 Santa Monica Blvd Suite 306a, West Hollywood, CA 90069",
  "NicePhone": "310-659-4455"
}];
